import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CompanyTierSettingService } from '../services/company-tier-setting.service';

@Injectable({
  providedIn: 'root',
})
export class LocalPickupScreenEnabledGuard {
  private authService = inject(AuthService);
  private companyTierSettingService = inject(CompanyTierSettingService);
  private router = inject(Router);

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let isLocalPickupScreenEnabled = false;
    try {
      const tierSettings = await this.companyTierSettingService.getCompanyTier(this.authService.user.companyId);
      isLocalPickupScreenEnabled = tierSettings?.localPickupScreenEnabled ?? false;
    } catch (error) {
      console.error(error);
    }
    if (isLocalPickupScreenEnabled) {
      return true;
    }
    return this.router.navigate(['/orders']);
  }
}
